import {BINGO_ROOMS_IMAGES, BINGO_ROOMS_SHARED_IMAGES} from "Setup/config";

export const getRoomImageFromRoomObject = (room) => {
    const isSpecificRoomImagery = room?.isSpecificImage ?? true;
    const roomImagePath = isSpecificRoomImagery ? BINGO_ROOMS_IMAGES : BINGO_ROOMS_SHARED_IMAGES;
    return `${roomImagePath}/${room.image}`;
};
